module.exports = __webpack_public_path__ + "img/0499e6_35c9d98cc15142cf9c3594f291d4ca60_mv2.807a6d57.webp";